import React from 'react';
import { Link } from 'react-router-dom';
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType';
import { TotalBalancetype, TrialBalanceType } from '../../../../redux/reports/reportsType';
import { Iicon } from '../../../../assets/images';
import { currencySignAndNegativeValueAdjust } from '../../../../utils/commonFunctions';

type AppProps = {
  trialBalanceData: [] | TrialBalanceType[];
  tableHeaders: TableHeadersType[];
  totalBalances: TotalBalancetype;
  client_code?: any;
  company_name?: any;
  start_date: string;
  end_date: string;
  isLedgerStatementPresent?: boolean;
  currencySign: string | undefined;
  handleCustomerSuplierDetailsData: (invoiceType: number) => void;
}

const TrialBalanceTableData = ({
  trialBalanceData,
  totalBalances,
  tableHeaders,
  client_code,
  company_name,
  start_date,
  end_date,
  isLedgerStatementPresent,
  currencySign,
  handleCustomerSuplierDetailsData
}: AppProps) => {


  const finalRedirectLink = {
    pathname: `/reports/${client_code}/ledger-statement?client_code=${client_code}&company_name=${company_name}`,
  }

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem('ledger_id', ledgerId.toString());
    localStorage.setItem('start_date', start_date);
    localStorage.setItem('end_date', end_date);
  }

  const renderTableData = () => {
    const finalTableData = trialBalanceData && trialBalanceData?.length > 0 && trialBalanceData?.map((tableData: TrialBalanceType, index: number) => {
      if (trialBalanceData?.length-1 === index) {
        return<></>
      }
      return (
        <>
          <tr key={tableData?.ledger_id}>
            {
              tableHeaders?.length && tableHeaders.map((header: TableHeadersType) => {
                if (header?.value === 'ledger_name') {
                  return <td
                    className='text-start'
                  >
                    {isLedgerStatementPresent ? <Link
                      target='_blank'
                      to={finalRedirectLink}
                      onClick={() => handleSetLocalStorageData(tableData?.ledger_id)}
                      style={{ textDecoration: 'none' ,cursor:"pointer"}}
                    >
                      {tableData?.ledger_name}
                    </Link> : tableData?.ledger_name}
                    {tableData?.ledger_type_id === 2 ? <img className='ml-2 pointer ' alt='eye' src={Iicon} onClick={() => handleCustomerSuplierDetailsData?.(tableData?.ledger_id)} /> : ""}
                  </td>
                } else if (header?.value === 'opening_balance') {
                  return <td className='text-start'>
                    {currencySignAndNegativeValueAdjust(currencySign,tableData?.opening_balance?tableData?.opening_balance?.toString():"0")}</td>
                } else if (header?.value === 'total_debit_amount') {
                  return <td className='text-start text-success'>
                    {currencySignAndNegativeValueAdjust(currencySign,tableData?.total_debit_amount?tableData?.total_debit_amount?.toString():"0")}</td>
                } else if (header?.value === 'total_credit_amount') {
                  return <td className='text-start text-danger'>
                    {currencySignAndNegativeValueAdjust(currencySign,tableData?.total_credit_amount?tableData?.total_credit_amount?.toString():"0")}</td>
                } else if (header?.value === 'closing_balance') {
                  return <td className='text-start'>
                    {currencySignAndNegativeValueAdjust(currencySign,tableData?.closing_balance?tableData?.closing_balance?.toString():"0")}</td>
                }
              })
            }
          </tr>
        </>
      )
    });

    return finalTableData;
  }

  return (
    <>
      {renderTableData()}
      <tr>
        <td className='text-start'>
          <strong>Total Amount</strong>
        </td>
        <td className='text-start'>
          <strong>{currencySignAndNegativeValueAdjust(currencySign,totalBalances?.total_opening_balance?totalBalances?.total_opening_balance?.toFixed(2)?.toString():"0")}</strong>
        </td>
        <td className='text-start'>
          <strong>{currencySignAndNegativeValueAdjust(currencySign,totalBalances?.total_debit_amount?totalBalances?.total_debit_amount?.toFixed(2)?.toString():"0")}</strong>
        </td>
        <td className='text-start'>
          <strong>{currencySignAndNegativeValueAdjust(currencySign,totalBalances?.total_credit_amount?totalBalances?.total_credit_amount?.toFixed(2)?.toString():"0")}</strong>
        </td>
        <td className='text-start'>
          <strong>{currencySignAndNegativeValueAdjust(currencySign,totalBalances?.total_closing_balance?totalBalances?.total_closing_balance?.toFixed(2)?.toString():"0")}</strong>
        </td>
      </tr>
    </>
  )
};

export default TrialBalanceTableData;